import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { AdviDTO } from '../../../../dto/advi/advi.dto';
import { environment } from '../../../../environment/environment';

export const addAdvisory = (dataDestService: any, componentDataSourceService: ComponentDataSourceService) => {
  return (data: AdviDTO): Observable<any> => {
    
    return dataDestService.http.post(
      `${environment.apiUrl}/advi`,
      data
    ).pipe(
      catchError(error => {
        console.error('[addAdvisory] Error response:', error);
        throw error;
      })
    );
  };
};
